import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LiveRegionProvider } from './components/ui/LiveRegion';
import { Home } from './pages/Home';
import { WhatsOn } from './pages/WhatsOn';
import { EventDetail } from './pages/EventDetail';
import { FoodAndDrink } from './pages/FoodAndDrink';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Gallery } from './pages/Gallery';
import { Visit } from './pages/Visit';
import { LegalDocument } from './pages/LegalDocument';
import { CompanyDetails } from './pages/CompanyDetails';
import { NotFound } from './pages/NotFound';

/**
 * Routing and providers only.
 *
 * The live region provider sits above the router so the route announcer in
 * PageLayout can reach it — there is one polite region for the whole site,
 * shared by navigation announcements, filter results and form results.
 */
export function App() {
  return <LiveRegionProvider data-id="element-0" data-mp="23utas12ahw9q">
      <BrowserRouter data-id="element-1" data-mp="23ti8k5ohswkq">
        <Routes data-id="element-2" data-mp="3ik7eyd5x05p2">
          <Route path="/" element={<Home data-id="element-4" data-mp="3ij61k21ff746" />} data-id="element-3" data-mp="3ikqyfyb7r257" />
          <Route path="/whats-on" element={<WhatsOn data-id="element-6" data-mp="3mlayb9n68jv1" />} data-id="element-5" data-mp="3ihv2gfixenje" />
          <Route path="/whats-on/:slug" element={<EventDetail data-id="element-8" data-mp="3mjg9vlcoy9m7" />} data-id="element-7" data-mp="3mkhlbqxmcy4g" />
          <Route path="/food-and-drink" element={<FoodAndDrink data-id="element-10" data-mp="3rdatypw7kqlt" />} data-id="element-9" data-mp="3rcj6618urx63" />
          <Route path="/shop" element={<Shop data-id="element-12" data-mp="5ygolyg4xb6" />} data-id="element-11" data-mp="3recerm310rgq" />
          <Route path="/shop/:slug" element={<ProductDetail data-id="element-14" data-mp="5ggxfcks0yi" />} data-id="element-13" data-mp="67yhm9c7y5s" />
          <Route path="/gallery" element={<Gallery data-id="element-16" data-mp="2zlv66six0xu0" />} data-id="element-15" data-mp="7sxpp6lk59z" />
          <Route path="/visit" element={<Visit data-id="element-18" data-mp="2zn6cp03qwjot" />} data-id="element-17" data-mp="2zmemy5wtxg6g" />
          {/* Company details is declared BEFORE the slug route, so it is
              matched as itself rather than looked up as a document. */}
          <Route path="/legal/company-details" element={<CompanyDetails data-id="element-20" data-mp="3dkuws5pznmst" />} data-id="element-19" data-mp="38l017ov9q91f" />
          <Route path="/legal/:slug" element={<LegalDocument data-id="element-22" data-mp="3dm5y7yvyoigr" />} data-id="element-21" data-mp="3dl4ktnrh3jvv" />
          <Route path="*" element={<NotFound data-id="element-24" data-mp="nwc2huqftzxb" />} data-id="element-23" data-mp="nvj35ett6cp7" />
        </Routes>
      </BrowserRouter>
    </LiveRegionProvider>;
}